// @ts-nocheck
import { useContext, useEffect, useState } from 'react';

// import { Slide } from '@mui/material';
import React from 'react';
// import { TransitionProps } from '@mui/material/transitions';
import { useNavigate, useParams } from 'react-router-dom';

import { Container, Row, Col, Breadcrumb, BreadcrumbItem, Chip, ChipLabel } from 'design-react-kit';

import ApiService from 'services/api';

import { Service } from '../models/service';
import ServiceContentsView from './service_content';
import { Helmet } from 'react-helmet-async';
import { ActaAuthContext } from 'pa_kit/auth';
import parse from 'html-react-parser';
import WidgetPageRating from 'pa_kit/apps/page_evaluation/components/widget_page_rating';
import WidgetContacts from 'pa_kit/apps/contacts/components/widget_contacts';
import authApiService from 'pa_kit/services/api';
import { TagClass } from 'pa_kit/apps/tags/models/tag';
import env from 'env';
import ShareButtons from 'apps/utils/share_buttons';

//import { ActaButton } from '@actainfo/actainfo-pa-kit';


// const AlertBottomUpTransition = React.forwardRef(function Transition(
//     props: TransitionProps & {
//       children: React.ReactElement<any, any>;
//     },
//     ref: React.Ref<unknown>,
//   ) {
//     return <Slide direction="up" ref={ref} {...props} />;
// });

const ServiceView = (props) => {
  
    const [ service, _setService ] = useState();
    const [ tags, _setTags ] = useState([]);

    //const navigate = useNavigate();
    const params = useParams();
    
    const auth = useContext(ActaAuthContext);
    const organization = auth.organization;    

    const actagov_config = auth.organization.active_licenses?.services?.actagov;

    useEffect(() => {
        fetchServices();
        fetchTags();
    }, []);


    const fetchServices = async () => {
        var responseData = await ApiService.getService(params.slug);
        _setService(responseData);
    }
    const fetchTags = async () => {
        var responseData = await authApiService.getTags();
        _setTags(responseData);
    }

    /*
    if(isLoading) {
        return (
              <Stack direction="column" gap={2}>
                <Stack direction="column" gap={2} sx={{ marginY: 4, alignItems:"left", color: "white"  }}>
                    <ButtonGroup variant="outlined" color="inherit" size="small">
                        <Button onClick={() => navigate("/")}>HOME</Button>
                        <Button onClick={() => navigate("/services")}>SERVIZI</Button>
                    </ButtonGroup>
                </Stack>
                <Paper elevation={2} sx={{ padding: 4, marginBottom: 8 }}>
                    <Loading />
                </Paper>
            </Stack>
        );
    }
    */

    if(service){
        return (
            <>

                <Helmet>
                    <title>{service.name} | {auth.organization.name}</title>
                </Helmet>
                <Container fluid>
                    <Container className="mt-5">
                        <Breadcrumb data-element="breadcrumb">
                            <BreadcrumbItem>
                                <a href='/'>Home</a>
                                <span className='separator'>/</span>
                            </BreadcrumbItem>
                            <BreadcrumbItem>
                                <a href='/servizi/'>Servizi</a>
                                <span className='separator'>/</span>
                            </BreadcrumbItem>
                            {service.category && (
                                <BreadcrumbItem>
                                    <a href={"/servizi/" + service.category.slug + '/'} data-element="service-area">{service.category.name}</a>
                                    <span className='separator'>/</span>
                                </BreadcrumbItem>
                            )}
                            <BreadcrumbItem>
                                {service.name}
                            </BreadcrumbItem>
                        </Breadcrumb>

                        <Row>
                            <Col lg="8">
                                <h1 data-element="service-title">{service.name}</h1>
                                <div data-element="service-description">
                                    { parse(service.description) }
                                </div>
                                {/*
                                <ActaButton />
                                */}
                            </Col>
                            <Col lg="4" >
                                <ShareButtons url={actagov_config?.frontend_url + 'servizio/' + service.slug + '/'} title={service.name} />
                                <p className="mb-0"><small>Stato del servizio</small></p>
                                <Chip simple color='success' key="key_tag_status" className="mr-2">
                                    <ChipLabel  data-element="service-status">ATTIVO</ChipLabel>
                                </Chip>
                                <p className="mb-0 mt-2"><small>Argomenti</small></p>
                                {service.tags.map((slug, index) => {
                                    let topic = tags.find(tag => tag.slug === slug);
                                    if(topic){
                                        return (
                                            <a data-element="service-topic" href={env.ACTAGOV_BASE_URL + "argomenti/" + topic.slug + '/'}>
                                                <Chip simple color='primary' key={"key_tag_" + index} className="mr-2">
                                                    <ChipLabel>{topic.name}</ChipLabel>
                                                </Chip>
                                            </a>
                                        )
                                    }else{
                                        return (
                                            <Chip simple color='secondary' key={"key_tag_" + index} className="mr-2">
                                                <ChipLabel>{slug}</ChipLabel>
                                            </Chip>
                                        )
                                    }
                                })}
                            </Col>
                        </Row>
                    </Container>
                </Container>
                <Container fluid>
                    <Container className="mt-5 service-container">
                        <ServiceContentsView service={service} />
                    </Container>
                </Container>
            
                <Container fluid className={'rating-wrapper page-rating news-page-rating'}>
                    <WidgetPageRating page_title={service.name} />
                </Container>

                <Container fluid className={'contacts-wrapper news-page-contacts'}>
                    <WidgetContacts />
                </Container>

                <script data-element="metatag" type="application/ld+json">
                    { `
                        { 
                            "name": "` + service.name + `", 
                            "serviceType": "` + service.category.name + `", 
                            "serviceOperator": {  
                                "name": "` + organization.name + `" 
                            },
                            "areaServed": {  
                                "name": "` + organization.name + `" 
                            }, 
                            "audience": {  
                                "audienceType": "` + (service.contents.recipients?.description).replace(/<[^>]+>/g, '') + `"
                            }, 
                            "availableChannel": {
                                "serviceUrl": "` + window.location + `",  
                                "serviceLocation": { 
                                    "name": "` + organization.name + `", 
                                    "address": {  
                                        "streetAddress": "` + organization.address + `",   
                                        "postalCode": "` + organization.address + `",   
                                        "addressLocality": "` + organization.name + `" 
                                    }   
                                }  
                            }  
                        }
                    ` }
                </script> 

            </>
        );
    }

    return <>"errore"</>;
}
export default ServiceView;
